export default __webpack_public_path__ + "static/media/final-feedback-full-logo-raw.cf7a980d.png";